import CreateLenderLoanParticipation from "./CreateLenderLoanParticipation.jsx";

export default CreateLenderLoanParticipation;
